import React, { useMemo, useState } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Table,
  Button,
  Space,
  Tooltip
} from '@lockerpm/design';

import {
  PrinterOutlined,
  EyeOutlined,
  EyeInvisibleOutlined
} from "@ant-design/icons";

import itemsComponents from "../../../../../components/items";
import { validateUrl } from "../../../../../utils/validate";

const TableData = (props) => {
  const { TextCopy } = itemsComponents;

  const { t } = useTranslation();
  const {
    loading = false,
    className = '',
    data = [],
    params = {},
    onUpdate = () => {},
  } = props;

  const isReadOnly = useSelector((state) => state.project.isReadOnly)
  
  const [showText, setShowText] = useState(false)

  const columns = useMemo(() => {
    return [
      {
        title: t('common.no'),
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 80,
      },
      {
        title: t('secret.key'),
        dataIndex: 'key',
        key: 'key',
        width: 200,
        align: 'left',
        render: (_, record) => <TextCopy
          value={record.leakedSecret.key}
        />
      },
      {
        title: <div className="flex items-center justify-between">
          <p>{t('secret.value')}</p>
          <div className="pr-1 cursor-pointer" onClick={() => setShowText(!showText)}>
            {
              !showText ? <EyeOutlined /> : <EyeInvisibleOutlined />
            }
          </div>
        </div>,
        dataIndex: 'value',
        key: 'value',
        align: 'left',
        width: 300,
        render: (_, record) => <TextCopy
          show={showText}
          align={'between'}
          value={record.leakedSecret.value}
        />
      },
      {
        title: t('leaked_secrets.location'),
        dataIndex: 'location',
        key: 'location',
        width: 200,
        align: 'left',
        render: (_, record) => {
          const safeUrl = validateUrl(record?.leakedSecret?.location, false);
          return (
            <a
              href={safeUrl || undefined}
              target={safeUrl ? "_blank" : undefined}
              rel={safeUrl ? "noopener noreferrer" : undefined}
              onClick={(e) => {
                if (!safeUrl) {
                  e.preventDefault();
                }
              }}
            >
              <TextCopy
                value={record?.leakedSecret?.location}
              />
            </a>
          );
        }
      },
      {
        title: t('leaked_secrets.line_in_code'),
        dataIndex: 'line_in_code',
        key: 'line_in_code',
        width: 80,
        align: 'right',
        render: (_, record) => <TextCopy
          align="end"
          value={record.leakedSecret.lineInCode}
        />
      },
      {
        title: t('common.actions'),
        dataIndex: 'actions',
        key: 'actions',
        align: 'center',
        fixed: 'right',
        width: 100,
        render: (_, record) => (
          <Space size={[8, 8]}>
            {
              !isReadOnly && <Tooltip
                title={t('leaked_secrets.tooltip.store_in')}
              >
                <Button
                  icon={<PrinterOutlined />}
                  type={'text'}
                  onClick={() => onUpdate(record)}
                ></Button>
              </Tooltip>
            }
          </Space>
        ),
      },
    ].filter((c) => !c.hide)
  }, [showText]) 
  return (
    <Table
      className={className}
      columns={columns}
      dataSource={data.map((d, index) => ({ ...d, stt: index + 1 + (params.page - 1) * params.size }))}
      loading={loading}
      pagination={false}
      rowKey={(record) => record?.id}
      size="small"
      scroll={{ x: 1024 }}
    />
  );
}

export default TableData;
